import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
//primeng

import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { ChipsModule } from 'primeng/chips';
import { DropdownModule } from 'primeng/dropdown';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { CascadeSelectModule } from 'primeng/cascadeselect';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { TabMenuModule } from 'primeng/tabmenu';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { AccordionModule } from 'primeng/accordion';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { DialogModule } from 'primeng/dialog';
import { StepsModule } from 'primeng/steps';
import { SelectButtonModule } from 'primeng/selectbutton';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TreeModule } from 'primeng/tree';
import { PanelMenuModule } from 'primeng/panelmenu';
import { ChartModule } from 'primeng/chart';
import { RippleModule } from 'primeng/ripple';
import { BadgeModule } from 'primeng/badge';
import { CheckboxModule } from 'primeng/checkbox';
import { FileUploadModule } from 'primeng/fileupload';
import { PasswordModule } from 'primeng/password';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { ChipModule } from 'primeng/chip';
import { ColorPickerModule } from 'primeng/colorpicker';
import { KnobModule } from 'primeng/knob';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

//components

import { TabelaPadraoComponent } from './components/tabela-padrao/tabela-padrao.component';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { BotaoComponent } from './components/botao/botao.component';
import { ToggleSelectComponent } from './components/toggle-select/toggle-select.component';
import { RadiusComponent } from './components/radius/radius.component';
import { SwitchComponent } from './components/switch/switch.component';
import { MenuLateralComponent } from './components/menu-lateral/menu-lateral.component';
import { MenuTopoComponent } from './components/menu-topo/menu-topo.component';
import { TableComponent } from './components/table/table.component';
import { StepsComponent } from './components/steps/steps.component';
import { StepComponent } from './components/step/step.component';
import { ModalService } from './services/modal.service';
import { SelectWeekComponent } from './components/select-week/select-week.component';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TabsComponent } from './components/tabs/tabs.component';
import { SplitTableComponent } from './components/split-table/split-table.component';
import { SplitListBadgeComponent } from './components/split-list-badge/split-list-badge.component';
import { SplitTextComponent } from './components/split-text/split-text.component';
import { SplitCardComponent } from './components/split-card/split-card.component';
import { SplitSearchComponent } from './components/split-search/split-search.component';
import { SplitHeaderSectionComponent } from './components/split-header-section/split-header-section.component';
import { SplitButtonFilterComponent } from './components/split-button-filter/split-button-filter.component';
import { SplitTruncateTextComponent } from './components/split-truncate-text/split-truncate-text.component';
import { SplitBarComponent } from './components/split-bar/split-bar.component';
import { SplitButtonCardComponent } from './components/split-button-card/split-button-card.component';
import { SplitHeaderFormComponent } from './components/split-header-form/split-header-form.component';
import { SplitTableCardComponent } from './components/split-table-card/split-table-card.component';
import { SplitStatusComponent } from './components/split-status/split-status.component';
import { SplitIconComponent } from './components/split-icon/split-icon.component';
import { SplitSheetModalComponent } from './components/split-sheet-modal/split-sheet-modal.component';
import { LineWithButtonComponent } from './components/line-with-button/line-with-button.component';
import { BadgeComponent } from './components/badge/badge.component';
import { LineWithButtonsComponent } from './components/line-with-buttons/line-with-buttons.component';
import { LineTrashPlusComponent } from './components/line-trash-plus/line-trash-plus.component';
import { SplitFileUploadComponent } from './components/split-file-upload/split-file-upload.component';
import { SplitHideTextComponent } from './components/split-hide-text/split-hide-text.component';
import { SplitSelectButtonComponent } from './components/split-select-button/split-select-button.component';
import { TruncateTextDirective } from './directives/truncate-text.directive';
import { SplitInsideMenuComponent } from './components/split-inside-menu/split-inside-menu.component';
import { SplitButtonFiltersComponent } from './components/split-button-filters/split-button-filters.component';
import { SplitChipFilterComponent } from './components/split-chip-filter/split-chip-filter.component';
import { SplitTaggleStatusComponent } from './components/split-taggle-status/split-taggle-status.component';
import { SplitDateSlideComponent } from './components/split-date-slide/split-date-slide.component';
import { SplitTableCalendarComponent } from './components/split-table-calendar/split-table-calendar.component';
import { FilterByIdPipe } from './pipe/filterById/filter-by-id.pipe';
import { SplitDoughnutComponent } from './components/split-doughnut/split-doughnut.component';
import { SplitDropdownDateComponent } from './components/split-dropdown-date/split-dropdown-date.component';
import { DisableAlertComponent } from './components/disable-alert/disable-alert.component';
import { SplitFilterMenuComponent } from './components/split-filter-menu/split-filter-menu.component';
import { SplitReportTableComponent } from './components/split-report-table/split-report-table.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SplitLineComponent } from './components/split-line/split-line.component';
import { DataNamePipe } from './components/split-line/data-name.pipe';
import { ReportMessageComponent } from './components/report-message/report-message.component';
import { SplitReportMessageYearMonthComponent } from './components/split-report-message-year-month/split-report-message-year-month.component';
import { ResultsPerMonthComponent } from './components/results-per-month/results-per-month.component';
import { MenuModule } from 'primeng/menu';
import { SplitProgressBarComponent } from './components/split-progress-bar/split-progress-bar.component';
import { SplitDoughnutV2Component } from './components/split-doughnut-v2/split-doughnut-v2.component';
import { PaginatorModule } from 'primeng/paginator';
import { SplitPaginatorComponent } from './components/split-paginator/split-paginator.component';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { SplitAppointmentCardComponent } from './components/split-appointment-card/split-appointment-card.component';
import { TooltipModule } from 'primeng/tooltip';
import { SidebarModule } from 'primeng/sidebar';
import { SplitFullCalendarComponent } from './components/split-full-calendar/split-full-calendar.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { ValidatorFormFieldDirective } from './directives/validator-form-field.directive';
import { ConvertTypePaymentPipe } from './pipe/convert-type-payment.pipe';
import { MaskInputCalendarDirective } from './directives/mask-input-calendar.directive';
import { SplitLoadingComponent } from './components/split-loading/split-loading.component';
import { SplitFilterDropdownComponent } from './components/split-filter-dropdown/split-filter-dropdown.component';
import { SplitFilterRangeDateComponent } from './components/split-filter-range-date/split-filter-range-date.component';
import { SplitChartLineComponent } from './components/split-chart-line/split-chart-line.component';
import { HelpFormComponent } from './components/help-form/help-form.component';
import { SplitGroupFilterComponent } from './components/split-group-filter/split-group-filter.component';
import { SplitFilterExpenseComponent } from './components/split-filter-expense/split-filter-expense.component';
import { SplitFilterProfessionalComponent } from './components/split-filter-professional/split-filter-professional.component';
import { SplitFilterYearComponent } from './components/split-filter-year/split-filter-year.component';
import { SplitFilterUnitComponent } from './components/split-filter-unit/split-filter-unit.component';
import { SplitFilterOptionComponent } from './components/split-filter-option/split-filter-option.component';
import { ListboxModule } from 'primeng/listbox';
import { SplitFilterPaymentMethodComponent } from './components/split-filter-payment-method/split-filter-payment-method.component';
import { SplitFilterExamComponent } from './components/split-filter-exam/split-filter-exam.component';
import { SplitFilterMonthComponent } from './components/split-filter-month/split-filter-month.component';
import { SplitFilterTextComponent } from './components/split-filter-text/split-filter-text.component';
import { AbbreviationTextComponent } from './components/abbreviation-text/abbreviation-text.component';
import { SplitFilterProfessionComponent } from './components/split-filter-profession/split-filter-profession.component';
import { SplitFilterSpecialtiesComponent } from './components/split-filter-specialties/split-filter-specialties.component';
import { SplitInputDateTaggleComponent } from './components/split-input-date-taggle/split-input-date-taggle.component';
import { SplitLegendRevenueComponent } from './components/split-legend-revenue/split-legend-revenue.component';
import { SplitTextKeyValueComponent } from './components/split-text-key-value/split-text-key-value.component';
import { SplitTooltipTextComponent } from './components/split-tooltip-text/split-tooltip-text.component';
import { SplitIconStatusComponent } from './components/split-icon-status/split-icon-status.component';
import { SplitTooltipInfoComponent } from './components/split-tooltip-info/split-tooltip-info.component';
import { NgxMaskModule } from 'ngx-mask';
import { SplitAddressFormComponent } from './components/split-address-form/split-address-form.component';
import { SplitRepresentativeFormComponent } from './components/split-representative-form/split-representative-form.component';
import { SplitActionConfirmModalComponent } from './components/split-action-confirm-modal/split-action-confirm-modal.component';
import { SplitControlErrorsComponent } from './components/split-control-errors/split-control-errors.component';
import { SplitReplaceTextPipe } from './pipes/split-replace-text.pipe';
import { SplitCheckingAccountInputComponent } from './components/split-checking-account-input/split-checking-account-input.component';
import { SplitTotalTableComponent } from './components/split-total-table/split-total-table.component';
import { SplitGroupCardComponent } from './components/split-group-card/split-group-card.component';
import { SplitFilterComponent } from './components/split-filter/split-filter.component';
import { SplitMultiSelectComponent } from './components/split-multi-select/split-multi-select.component';
import { SplitMapJoinPipe } from './pipes/split-map-join.pipe';
import { ChevronDownIcon } from "primeng/icons/chevrondown";
import { SearchIcon } from "primeng/icons/search";
import { SplitDropdownBankComponent } from './components/split-dropdown-bank/split-dropdown-bank.component';
import { SupportChatComponent } from './components/support-chat/support-chat.component';
import { SplitLoadingPlaceholderComponent } from './components/split-loading-placeholder/split-loading-placeholder.component';
import { SplitInfiniteScrollDirective } from './directives/split-infinite-scroll.directive';
import { SplitFilterDateComponent } from './components/split-filter-date/split-filter-date.component';
import { SplitSelectedFiltersChipsComponent } from './components/split-selected-filters-chips/split-selected-filters-chips.component';
import { CamelCaseTextDirective } from './directives/camel-case-text.directive';
import { SplitWithdrawalBalanceComponent } from './components/split-withdrawal-balance/split-withdrawal-balance.component';

const sharedComponents = [
  SplitProgressBarComponent,
  TabelaPadraoComponent,
  BotaoComponent,
  ToggleSelectComponent,
  RadiusComponent,
  SwitchComponent,
  MainLayoutComponent,
  MenuLateralComponent,
  MenuTopoComponent,
  TableComponent,
  StepsComponent,
  StepComponent,
  SelectWeekComponent,
  TabsComponent,
  SplitHeaderSectionComponent,
  SplitSearchComponent,
  SplitCardComponent,
  SplitButtonFilterComponent,
  SplitTableComponent,
  SplitListBadgeComponent,
  SplitTextComponent,
  SplitTruncateTextComponent,
  SplitBarComponent,
  SplitButtonCardComponent,
  SplitHeaderFormComponent,
  SplitTableCardComponent,
  SplitStatusComponent,
  SplitIconComponent,
  SplitSheetModalComponent,
  SplitFileUploadComponent,
  LineWithButtonComponent,
  SplitHideTextComponent,
  SplitSelectButtonComponent,
  BadgeComponent,
  LineWithButtonsComponent,
  SplitInsideMenuComponent,
  SplitHideTextComponent,
  SplitSelectButtonComponent,
  BadgeComponent,
  LineTrashPlusComponent,
  TruncateTextDirective,
  SplitButtonFiltersComponent,
  SplitTaggleStatusComponent,
  SplitDateSlideComponent,
  SplitTableCalendarComponent,
  SplitChipFilterComponent,
  SplitDoughnutComponent,
  SplitFilterMenuComponent,
  SplitReportTableComponent,
  FilterByIdPipe, //pipe
  SplitDropdownDateComponent,
  DisableAlertComponent,
  SplitLineComponent,
  ReportMessageComponent,
  SplitReportMessageYearMonthComponent,
  ResultsPerMonthComponent,
  SplitDoughnutV2Component,
  SplitPaginatorComponent,
  SplitAppointmentCardComponent, 
  DataNamePipe,
  SplitFullCalendarComponent,
  ConvertTypePaymentPipe,
  MaskInputCalendarDirective,
  SplitLoadingComponent,
  SplitFilterDropdownComponent,
  SplitFilterRangeDateComponent,
  SplitChartLineComponent,
  SplitGroupFilterComponent,
  SplitFilterExpenseComponent,
  SplitFilterYearComponent,
  SplitFilterProfessionalComponent,
  SplitFilterUnitComponent,
  SplitFilterOptionComponent,
  SplitFilterPaymentMethodComponent,
  SplitFilterExamComponent,
  SplitFilterMonthComponent,
  SplitFilterTextComponent,
  AbbreviationTextComponent,
  SplitFilterProfessionComponent,
  SplitFilterSpecialtiesComponent,
  SplitInputDateTaggleComponent,
  SplitLegendRevenueComponent,
  SplitTextKeyValueComponent,
  SplitTooltipTextComponent,
  SplitIconStatusComponent,
  SplitTooltipInfoComponent,
  SplitAddressFormComponent,
  SplitRepresentativeFormComponent,
  SplitActionConfirmModalComponent,
  SplitControlErrorsComponent,
  SplitCheckingAccountInputComponent,
  SplitReplaceTextPipe,
  SplitTotalTableComponent,
  SplitGroupCardComponent,
  SplitFilterComponent,
  SplitMultiSelectComponent,
  SplitMapJoinPipe,
  SplitDropdownBankComponent,
  SupportChatComponent,
  SplitLoadingPlaceholderComponent,
  SplitInfiniteScrollDirective,
  SplitFilterDateComponent,
  SplitSelectedFiltersChipsComponent,
  CamelCaseTextDirective,
  SplitWithdrawalBalanceComponent
];
const sharedModules = [
  TooltipModule,
  ReactiveFormsModule,
  AutoCompleteModule,
  CalendarModule,
  ChipsModule,
  DropdownModule,
  InputMaskModule,
  InputNumberModule,
  CascadeSelectModule,
  MultiSelectModule,
  InputTextareaModule,
  InputTextModule,
  ButtonModule,
  TabMenuModule,
  MenuModule,
  AccordionModule,
  OverlayPanelModule,
  DynamicDialogModule,
  DialogModule,
  StepsModule,
  SelectButtonModule,
  InputSwitchModule,
  RadioButtonModule,
  PasswordModule,
  TreeModule,
  PanelMenuModule,
  FormsModule,
  MessagesModule,
  MessageModule,
  ChartModule,
  RippleModule,
  BadgeModule,
  CheckboxModule,
  FileUploadModule,
  ChipModule,
  ColorPickerModule,
  ProgressSpinnerModule,
  PaginatorModule,
  ToastModule,
  TreeModule,
  SidebarModule,
  FullCalendarModule,
  KnobModule,
  ListboxModule,
  ConfirmDialogModule,
  NgxMaskModule
];

@NgModule({
  declarations: [
    ...sharedComponents,
    HelpFormComponent,
    SplitWithdrawalBalanceComponent
  ],
  imports: [CommonModule, RouterModule, ...sharedModules, ChevronDownIcon, SearchIcon],
  exports: [...sharedModules, ...sharedComponents],
  providers: [DialogService, ModalService, MessageService],
})
export class SharedModule { }
